import styles from "./SideMenu.module.css";
import {
  OptionMenu,
  OptionMenuDropDown,
} from "../../components/components-ui/OptionMenu/OptionMenu";
import { AuthContext } from "../../Provider/AuthContext";
import { useContext } from "react";
//
function SideMenu({ onClick, leave }) {
  const {
    idTipoUsuario,
    preposto,
    idEmiteMtr,
    idTipoContrapartida,
    idDepartamento,
  } = useContext(AuthContext);

  const opcoesMenu = JSON.parse(localStorage.getItem("menu"));

  //
  let rotasUsuarioTipo1 = {};
  let rotasUsuarioTipo3 = {};
  let rotasUsuarioTipo4 = {};
  let rotasUsuarioTipo5 = {};
  let rotasUsuarioGrupo = {};
  if (preposto === 0) {
    if (idTipoContrapartida === 2) {
      rotasUsuarioTipo1 = {
        option: [
          {
            title: "Solicitação de Coletas",
            icon: "fas fa-plus",
            link: "/local/",
          },
          // {
          //   title: 'Validação de Coleta',
          //   icon: 'fas fa-clipboard-check',
          //   link: '/local/validacao-de-coleta',
          // },
          {
            title: "Comprovante de pagamento",
            icon: "fas fa-file-invoice-dollar",
            link: "/local/comprovante-de-pagamento",
          },

          {
            isDrop: true,
            title: "Controle MTR",
            option: [
              {
                title: "Meus MTR's",
                icon: "fas fa-file",
                link: "/local/meus-mtr",
              },
              {
                title: "CDF's",
                icon: "fas fa-file",
                link: "/local/cdf",
              },
              {
                title: "Acesso MTR",
                icon: "fas fa-file",
                link: "/local/acesso-mtr",
              },
            ],
          },
          //
          {
            title: "Conta Bancária",
            icon: "fas fa-university",
            link: "/local/atualizar-conta",
          },
          {
            title: "Relatórios de coletas",
            icon: "fas fa-receipt",
            link: "/local/relatorio-de-coleta",
          },
          {
            title: "Certificados",
            icon: "fas fa-file",
            link: "/local/certificado",
          },
          {
            title: "Gestão de Licenças",
            icon: "fas fa-clipboard-list",
            link: "/local/gestao-de-licenca",
          },
        ],
      };
    } else {
      rotasUsuarioGrupo = {
        option: [
          {
            title: "Certificados Grupo",
            icon: "fas fa-file",
            link: "/local/certificado",
          },
          {
            title: "Gestão de Licenças",
            icon: "fas fa-clipboard-list",
            link: "/local/gestao-de-licenca",
          },
        ],
      };
      rotasUsuarioTipo1 = {
        option: [
          // {
          //   title: 'Solicitação de Coletas',
          //   icon: 'fas fa-plus',
          //   link: '/local/',
          // },
          {
            isDrop: true,
            title: "Controle MTR",
            option: [
              {
                title: "Meus MTR's",
                icon: "fas fa-file",
                link: "/local/meus-mtr",
              },
              {
                title: "CDF's",
                icon: "fas fa-file",
                link: "/local/cdf",
              },
              {
                title: "Acesso MTR",
                icon: "fas fa-file",
                link: "/local/acesso-mtr",
              },
            ],
          },
          {
            title: "Relatórios de coletas",
            icon: "fas fa-receipt",
            link: "/local/relatorio-de-coleta",
          },
          {
            title: "Certificados",
            icon: "fas fa-file",
            link: "/local/certificado",
          },
          {
            title: "Gestão de Licenças",
            icon: "fas fa-clipboard-list",
            link: "/local/gestao-de-licenca",
          },
        ],
      };
    }
    rotasUsuarioTipo3 = {
      option: [
        // {
        //   title: 'Analytics',
        //   icon: 'fas fa-chart-line',
        //   link: {
        //     pathname: 'https://www.triangulo.org.br/kpi.html',
        //   },
        //   target: '_blank',
        // },
        {
          title: "Painel",
          icon: "fas fa-th",
          link: "/local/painel",
        },
        {
          title: "Gestão de Licenças",
          icon: "fas fa-clipboard-list",
          link: "/local/gestao-de-licenca",
        },
        {
          title: "Relatórios de coletas",
          icon: "fas fa-receipt",
          link: "/local/relatorio-de-coleta/",
        },
      ],
    };
    rotasUsuarioTipo5 = {
      option: [
        {
          title: "Locais",
          icon: "fas fa-map",
          link: "/usina/",
        },
        {
          title: "Coleta",
          icon: "fas fa-chart-line",
          link: "/usina/coleta",
        },
      ],
    };
    rotasUsuarioTipo4 = {
      option: [
        {
          title: "Freguesias",
          icon: "fas fa-clipboard-check",
          link: "/local/freguesias",
        },
        // {
        //   title: 'Relatório de Conferência',
        //   icon: 'fas fa-hand-holding-usd',
        //   link: '/local/relatoriopagamento',
        // },
      ],
    };
  }
  if (preposto === 1) {
    rotasUsuarioTipo4 = {
      option: [
        {
          title: "Coletas",
          icon: "fas fa-clipboard-check",
          link: "/local/",
        },
        {
          title: "Roteiros",
          icon: "fas fa-clipboard-check",
          link: "/prep/local/roteiros",
        },
      ],
    };
  }

  const dropdowns = [
    {
      title: "Local",
      icon: "fas fa-plus",
      option: [
        {
          title: "Solicitação de Coletas",
          icon: "fas fa-plus",
          link: "/local/",
        },
        {
          title: "Validação de Coleta",
          icon: "fas fa-clipboard-check",
          link: "/local/validacao-de-coleta",
        },
        {
          title: "Comprovante de pagamento",
          icon: "fas fa-file-invoice-dollar",
          link: "/local/comprovante-de-pagamento",
        },
        {
          title: "Conta Bancária",
          icon: "fas fa-university",
          link: "/local/atualizar-conta",
        },
        {
          title: "Relatórios de coletas",
          icon: "fas fa-receipt",
          link: "/local/relatorio-de-coleta",
        },
        {
          title: "Certificados",
          icon: "fas fa-file",
          link: "/local/certificado",
        },
        {
          title: "Gestão de Licenças",
          icon: "fas fa-clipboard-list",
          link: "/local/gestao-de-licenca",
        },
      ],
      suboptions: [
        {
          subtitle: "Controle MTR",
          suboption: [
            {
              title: "Meus MTR's",
              icon: "fas fa-file",
              link: "/local/meus-mtr",
            },
            {
              title: "CDF's",
              icon: "fas fa-file",
              link: "/local/cdf",
            },
            {
              title: "Acesso MTR",
              icon: "fas fa-file",
              link: "/local/acesso-mtr",
            },
          ],
        },
      ],
    },

    {
      title: "Grupo",
      icon: "fas fa-plus",
      option: [
        {
          title: "Certificados Grupo",
          icon: "fas fa-file",
          link: "/local/certificado",
        },
        {
          title: "Gestão de Licenças",
          icon: "fas fa-clipboard-list",
          link: "/local/gestao-de-licenca",
        },
      ],
    },

    {
      title: "Coletas",
      icon: "fas fa-plus",
      option: [
        {
          title: "Solicitação de Coletas",
          icon: "fas fa-plus",
          link: "/local/",
        },

        {
          title: "Relatórios de coletas",
          icon: "fas fa-receipt",
          link: "/local/relatorio-de-coleta",
        },
        {
          title: "Certificados",
          icon: "fas fa-file",
          link: "/local/certificado",
        },
        {
          title: "Gestão de Licenças",
          icon: "fas fa-clipboard-list",
          link: "/local/gestao-de-licenca",
        },
      ],
      suboptions: [
        {
          subtitle: "Controle MTR",
          suboption: [
            {
              title: "Meus MTR's",
              icon: "fas fa-file",
              link: "/local/meus-mtr",
            },
            {
              title: "CDF's",
              icon: "fas fa-file",
              link: "/local/cdf",
            },
            {
              title: "Acesso MTR",
              icon: "fas fa-file",
              link: "/local/acesso-mtr",
            },
          ],
        },
      ],
    },

    {
      title: "Gestão",
      icon: "fas fa-plus",
      option: [
        {
          title: "Painel",
          icon: "fas fa-th",
          link: "/local/painel",
        },
        {
          title: "Gestão de Licenças",
          icon: "fas fa-clipboard-list",
          link: "/local/gestao-de-licenca",
        },
        {
          title: "Relatórios de coletas",
          icon: "fas fa-receipt",
          link: "/local/relatorio-de-coleta/",
        },
      ],
    },

    {
      title: "Motorista",
      icon: "fas fa-plus",
      option: [
        {
          title: "Freguesias",
          icon: "fas fa-clipboard-check",
          link: "/local/freguesias",
        },
        {
          title: "Relatório de Conferência",
          icon: "fas fa-hand-holding-usd",
          link: "/local/relatoriopagamento",
        },
      ],
    },
  ];

  let rotaUsuario = [];
  if (idTipoUsuario === 5 && idDepartamento == 9) {
    rotaUsuario = rotasUsuarioGrupo;
  } else if (idTipoUsuario === 1) {
    rotaUsuario = rotasUsuarioTipo1;
  } else if (idTipoUsuario === 3) {
    rotaUsuario = rotasUsuarioTipo3;
  } else if (idTipoUsuario === 4) {
    rotaUsuario = rotasUsuarioTipo4;
  } else if (idTipoUsuario === 5) {
    rotaUsuario = rotasUsuarioTipo5;
  }

  return (
    <div className={styles.containerLinks}>
      <ul>
        {/* Dropdown */}
        {/* Livre */}
        {/* {rotaUsuario?.option?.map((value, key) =>
          value.isDrop ? (
            <OptionMenuDropDown
              key={key}
              onClick={onClick}
              labelDropdown={value?.title}
              iconDropdown="fas fa-file"
              options={value?.option}
            />
          ) : (
            <OptionMenu
              key={key}
              link={value?.link}
              icon={value?.icon}
              title={value?.title}
              onClick={onClick}
              target={value?.target}
            />
          )
        )} */}

        {opcoesMenu?.map((value) => (
          <>
            {value.suboptions?.map((op, index) => (
              <OptionMenuDropDown
                key={index}
                labelDropdown={op?.subtitle}
                iconDropdown="fas fa-file"
                options={op.suboption}
              />
            ))}
            {value.option?.map((op, index) => (
              <OptionMenu
                key={index}
                link={op?.link}
                icon={op?.icon}
                title={op?.title}
                target={op?.target}
                onClick={onClick}
              />
            ))}
          </>
        ))}

        {/*  Opções Fixas  */}
        {/* {idTipoUsuario !== 4 ? (
          <OptionMenu
            link={{
              pathname: `https://api.whatsapp.com/send?phone=5511983279221&text=Olá,Necessito de um suporte`,
            }}
            icon="fab fa-whatsapp-square"
            title="Suporte"
            onClick={onClick}
            target="_blank"
          />
        ) : null} */}
        <OptionMenu
          link="/"
          icon="fas fa-sign-out-alt"
          title="Sair"
          onClick={leave}
        />
      </ul>
    </div>
  );
}

export default SideMenu;
